import { ColorVariant } from '../../components'
import { AppPlatform, AppRegion, TrafficDataViewEnum, TrafficSettings } from './types'

export const COOKIE_KEY = 'trafficSettings'

export const DEFAULT_SHOW_NUM_OF_APPS = 12

export const DEFAULT_SETTINGS: TrafficSettings = {
  trafficDataView: TrafficDataViewEnum.visits,
  chartView: 1,
  appPlatforms: [AppPlatform.android, AppPlatform.ios],
  appRegions: [AppRegion.us, AppRegion.ww],
}

export const SEGMENT_COLORS = Object.keys(ColorVariant).filter(
  (c) => c !== ColorVariant.gray && c !== ColorVariant.default
) as ColorVariant[]

export const AppPlatformLabels = {
  [AppPlatform.ios]: 'iOS',
  [AppPlatform.android]: 'Android',
}

export const AppRegionLabels = {
  [AppRegion.us]: 'USA',
  [AppRegion.ww]: 'Worldwide',
}

export const COMMON_COLUMN_CLASS_NAME = 'px-3.5 last:pr-11 w-17 min-w-17 max-w-17 last:w-24.5 relative'
